export const awsConfig = {
    Auth: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_5Mjwq4cWF',
      userPoolWebClientId: '4h63s5aemij1ft7u8489rv15nq',
    },
  };
  